import {PrimerComponentFaqGroupSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentFaqGroup'
import {PrimerComponentSubnavSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSubnav'

import {defineBrandPage, optionalSection, optionalTemplateField} from '../../../../brand/components/BrandPage'
import {findByIdWithSchema, GenericContentSchema, GenericSectionSchema} from '../../../../brand/lib/types/contentful'

import {toCompareTableContent} from './CompareTable/content'
import {toHeroSectionContent} from './HeroSection/content'

export const copilotPlansPage = defineBrandPage({
  comparison: optionalSection('featuresCopilotPlansComparison', GenericSectionSchema, toCompareTableContent),
  cta: optionalSection('featuresCopilotPlansCtaSection', GenericSectionSchema, ctaSection => ({
    cta: findByIdWithSchema(ctaSection.fields.content, 'featuresCopilotPlansCta', GenericContentSchema),
    sectionIntro: ctaSection.fields.sectionIntro,
  })),
  faq: optionalTemplateField('faq', PrimerComponentFaqGroupSchema),
  hero: optionalSection('featuresCopilotPlansHeroSection', GenericSectionSchema, heroSection => ({
    content: toHeroSectionContent(heroSection),
    section: heroSection,
  })),
  subnav: optionalTemplateField('subnav', PrimerComponentSubnavSchema),
})
